import React from 'react';
import CurrentAccoutDetail from 'components/Tvendo/Bank/DataMaster/Payments/CurrentAccout/Detail/List.js';

export default function () {
  return <CurrentAccoutDetail />;
}
